import { render, staticRenderFns } from "./MdArrowLeftIcon.vue?vue&type=template&id=8447c6a2"
import script from "./MdArrowLeftIcon.vue?vue&type=script&lang=js"
export * from "./MdArrowLeftIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports